import { isSubNavigationA } from '@core/typeguards';
import { getRetinaSrcs, imageUrl } from '@helpers/image';
import { useHoverIntent } from '@hooks/useHoverIntent';
import { ReactComponent as SvgArrow } from '@img/icons/button-arrow.svg';
import * as React from 'react';
import S from './NavigationDesktop.styles';
const Item = (props) => {
    const { ref: anchorRef } = useHoverIntent({
        onHover() {
            props.onActivateChange();
        },
    });
    return (React.createElement(S.Item, { key: props.item.id, ref: anchorRef, "data-active": props.active, "data-current": props.current, "data-has-submenu": props.item.children !== null && props.item.children.length > 0 },
        React.createElement(S.Link, { href: props.item.url, target: props.item.target }, props.item.text),
        renderSubNavigation()));
    function renderSubNavigation() {
        if (props.item.children !== null && props.item.children.length === 0) {
            return null;
        }
        const [activeSubNav, setActiveSubNav] = React.useState();
        const bounding = anchorRef.current?.getBoundingClientRect() ?? { left: 0, width: 0 };
        return (React.createElement(S.SubWrapper, { style: { left: bounding.left, width: `calc(100% - ${bounding.width}px)` } },
            React.createElement(S.SubInner, null,
                React.createElement(S.SubList, null, props.item.children !== null &&
                    props.item.children.map((item) => {
                        const { ref: subAnchorRef } = useHoverIntent({
                            onHover() {
                                setActiveSubNav(subAnchorRef.current?.id);
                            },
                            onBlur() {
                                setActiveSubNav(undefined);
                            },
                        });
                        return (React.createElement(S.SubItem, { key: item.id, id: item.id, ref: subAnchorRef, "data-active-sub": activeSubNav === item.id, "data-active-sub-image": !!item.image?.src },
                            React.createElement(S.SubLink, { href: item.url, target: item.target },
                                isSubNavigationA(item) && React.createElement(S.PreText, null, item.preText),
                                React.createElement("span", null, item.text)),
                            isSubNavigationA(item) && item.children ? (React.createElement(S.SubContent, { "data-has-content": true }, activeSubNav === item.id && (React.createElement(React.Fragment, null,
                                React.createElement(S.SubContentList, null, item.children.map((child) => (React.createElement("li", { key: child.id },
                                    React.createElement(S.SubContentLink, { href: child.url, target: child.target },
                                        child.text,
                                        React.createElement(SvgArrow, null)),
                                    child.children && (React.createElement(S.SubContentChildList, null, child.children.map((c) => (React.createElement("li", { key: c.id },
                                        React.createElement(S.SubContentLink, { href: c.url, target: c.target },
                                            c.text,
                                            React.createElement(SvgArrow, null))))))))))),
                                item.image && !!item.image?.src && (React.createElement(S.SubContentImage, { alt: "", role: "presentation", src: imageUrl(item.image, { width: 400, heightratio: 336 / 493 }), srcSet: getRetinaSrcs(item.image, 400, 336 / 493).join(',') })))))) : !!item.image?.src && (React.createElement(S.SubContent, null, activeSubNav === item.id && item.image && (React.createElement(S.SubContentImage, { alt: "", role: "presentation", src: imageUrl(item.image, { width: 800, heightratio: 765 / 493 }), srcSet: getRetinaSrcs(item.image, 800, 765 / 493).join(',') }))))));
                    })))));
    }
};
const NavigationDesktop = (props) => {
    return (React.createElement(S.Container, { "aria-label": "Desktop navigation", "data-overlay": props.showOverlay },
        React.createElement(S.List, { onMouseLeave: () => props.setActiveItem(undefined) }, props.items.map((item) => (React.createElement(Item, { key: `nav-item-${item.id}`, active: props.activeItem?.id === item.id, current: props.currentPage === item.id, item: item, onActivateChange: () => {
                props.setActiveItem(item);
            } }))))));
};
export default NavigationDesktop;
